<template>
  <span class="payment-container">
    <div
      v-if="!isCompatiable && getPlatform === 'iOS' && !showLoadingSpinner"
      class="p-3"
    >
      <p>Apple Pay is currently unavailable on this device</p>
      <p>Please setup apple pay or select a different method of payment</p>
      <p>
        To setup apple pay, you need to add a card to your account and enable in
        your devices settings
      </p>
      <p>Or go back to your account to select an alternative payment method</p>
    </div>
    <div
      v-else-if="!accountInfo && !showLoadingSpinner"
      class="no-apple-pay"
    >
      <p v-if="getPlatform === 'iOS'">
        Apple Pay is currently unavailable, please try again later or select a
        different method of payment
      </p>
      <p v-if="getPlatform !== 'iOS'">
        Google Pay is currently unavailable, please try again later or select a
        different method of payment
      </p>
    </div>
    <div
    v-else-if="accountInfo"
      class="m-3 mb-5"
    >
      <b-card
        class="my-4 text-center d-flex"
      >
        <h2 class="d-flex justify-content-center text-uppercase">
          Booking Reference: {{ bookingNo }}
        </h2>
      </b-card>
      <div v-if="finalPayment === false && barclaysSuccess === false">
        <b-card
          bg-variant="light"
          class="mb-2 text-center"
          style="height: 8%"
        >
          <h4>Cardholder Details</h4>
          <h6 class="card-h6">Add details as they appear on the card</h6>
        </b-card>

        <b-row
          class="my-4"
          align-h="around"
        >
          <b-col :cols="mobile ? 12 : 5">
            <b-form-group
              label="Cardholder Name"
              label-for="cardholder-name"
              label-size="sm"
            >
              <b-form-select
                v-model="selectedPassenger"
                :options="passengerOptions"
                :disabled="showPaymentOptions"
                @change="findPersonalData"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div v-if="selectedPassenger === 'guest'">
          <b-row
            class="mt-4"
            align-h="around"
          >
            <b-col :cols="mobile ? 12 : 5">
              <b-form-group
                label="Cardholder's Title"
                label-for="title"
                label-size="sm"
              >
                <b-form-select
                  v-model="cardholderTitle"
                  :disabled="showPaymentOptions"
                  :options="titles"
                />
              </b-form-group>
            </b-col>
            <b-col
              :cols="mobile ? 12 : 5"
              align-h="center"
            >
              <b-form-group
                label="Cardholder's First Name"
                label-for="cardholder-name"
                label-size="sm"
                :class="{ 'form-group--error': $v.cardholderName.$error }"
              >
                <b-form-input
                  id="card-name-input"
                  v-model="cardholderName"
                  :disabled="showPaymentOptions"
                />
                <div
                  v-if="!$v.cardholderName.required"
                  class="error"
                >
                  <span class="error-field">Name is required</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-h="around">
            <b-col :cols="mobile ? 12 : 5">
              <b-form-group
                label="Cardholder's Surname"
                label-for="cardholder-name"
                label-size="sm"
                :class="{ 'form-group--error': $v.cardholderSurname.$error }"
              >
                <b-form-input
                  id="card-name-input"
                  v-model="cardholderSurname"
                  :disabled="showPaymentOptions"
                />
                <div
                  v-if="!$v.cardholderSurname.required"
                  class="error"
                >
                  <span class="error-field">Surname is required</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col cols="5" />
          </b-row>
        </div>

        <div v-if="selectedPassenger">
          <b-card
            bg-variant="light"
            class="mb-4 text-center"
            :style="mobile === true ? 'height:100px' : 'height:70px'"
          >
            <h4 class="mb-4">Cardholder Contact Details</h4>
          </b-card>
          <b-row
            class="mt-5"
            align-h="around"
          >
            <b-col :cols="mobile ? 12 : 5">
              <b-form-group
                label="First line of address app"
                label-for="title"
                label-size="sm"
                :class="{ 'form-group--error': $v.cardholderAddress1.$error }"
              >
                <b-form-input
                  id="title-input"
                  v-model="cardholderAddress1"
                  :disabled="showPaymentOptions"
                />
                <div
                  v-if="!$v.cardholderAddress1.required"
                  class="error"
                >
                  <span class="error-field">Address is required</span>
                </div>
              </b-form-group>
            </b-col>
            <b-col
              :cols="mobile ? 12 : 5"
              align-h="center"
            >
              <b-form-group
                label="Second line of address"
                label-for="cardholder-name"
                label-size="sm"
                :class="{ 'form-group--error': $v.cardholderAddress2.$error }"
              >
                <b-form-input
                  id="card-name-input"
                  v-model="cardholderAddress2"
                  :disabled="showPaymentOptions"
                />
                <div
                  v-if="!$v.cardholderAddress2.required"
                  class="error"
                >
                  <span class="error-field">Address is required</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-h="around">
            <b-col :cols="mobile ? 12 : 5">
              <b-form-group
                label="Third line of address"
                label-for="cardholder-name"
                label-size="sm"
              >
                <b-form-input
                  id="card-name-input"
                  v-model="cardholderAddress3"
                />
              </b-form-group>
            </b-col>
            <b-col
              :cols="mobile ? 12 : 5"
              align-h="center"
            >
              <b-form-group
                :label="getTerritory() === 'UK' ? 'Postcode' : 'Eircode'"
                label-for="cardholder-name"
                label-size="sm"
                :class="{ 'form-group--error': $v.cardholderPostcode.$error }"
              >
                <b-form-input
                  id="card-name-input"
                  v-model="cardholderPostcode"
                  :disabled="showPaymentOptions"
                />
                <div
                  v-if="!$v.cardholderPostcode.required"
                  class="error"
                >
                  <span class="btn-outline-danger">Postcode is required</span>
                </div>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-h="around">
            <b-col :cols="mobile ? 12 : 10">
              <b-form-group
                label="Email address (where confirmation will be sent)"
                label-for="payment-email"
                label-size="sm"
              >
                <b-input-group prepend="@">
                  <b-form-input
                    id="email-input"
                    v-model="paymentEmail"
                    :disabled="showPaymentOptions"
                  />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row align-h="around">
            <b-col :cols="mobile ? 12 : 10">
              <b-form-group
                :label="fullPayment ? 'Amount to Pay' : 'Amount to Pay (editable)'"
                label-for="payment-email"
                label-size="sm"
              >
                <b-card
                  bg-variant="light"
                  class="mb-2 text-center"
                  :style="mobile === true ? 'height:140px' : 'height:100px'"
                  >
                  <b-row align-h="between">
                    <b-col
                      :cols="mobile ? 12 : 5"
                      class="mt-2"
                    >
                      <h5>
                        <p>Your outstanding balance is: {{ paymentCost }}</p>
                      </h5>
                    </b-col>
                    <b-col
                      :cols="mobile ? 12 : 5"
                      class="mt-2"
                    >
                      <b-input-group
                        :prepend="getTerritory() === 'UK' ? '£' : '€'"
                      >
                        <b-form-input
                          id="payment-input"
                          v-model="paymentCost"
                          :disabled="showPaymentOptions"
                          type="number"
                          :readonly="fullPayment"
                        />
                      </b-input-group>
                    </b-col>
                  </b-row>
                </b-card>
              </b-form-group>
            </b-col>
          </b-row>

          <b-card
            v-if="showPaymentOptions"
            bg-variant="light"
            class="mb-2 text-center w-100"
            :style="mobile === true ? 'height:100px' : 'height:70px'"
          >
            <div class="d-flex">
              <div class="w-50">
                <h4>
                  <p class="mb-4">Payment Options:</p>
                </h4>
              </div>
              <div class="w-50">
                <b-button
                  v-if="showPaymentOptions"
                  class="edit-btn float-right"
                  :style="
                    mobile
                      ? 'margin-bottom: 10px;'
                      : 'min-height: 77%; margin-bottom: 10px;'
                  "
                  variant="outline-dark"
                  @click="toggleEdit"
                >
                  Edit
                </b-button>
              </div>
            </div>
          </b-card>

          <div>
            <b-alert
              v-if="formInvalid"
              variant="danger"
              class="text-center"
              show
            >
              Please Complete All Fields On This Form In Order To Continue.
            </b-alert>
          </div>

          <div>
            <b-button
              v-if="modalPayType === 'card'"
              class="mt-3 ml-0 pay-btn"
              block
              variant="dark"
              @click="cardPaymentNext"
            >
              Credit Card
            </b-button>
          </div>

          <div
            v-if="!cardholderIntAddress"
            class="text-center d-flex justify-content-center"
          >
            <div
              v-if="!showPaymentOptions"
              class="mr-1 w-100"
            >
              <b-button
                class="mt-2 ml-0 pay-btn w-100"
                block
                variant="dark"
                @click="checkValidDetails"
              >
                Next<b-icon
                  class="ml-2"
                  icon="credit-card"
                  aria-hidden="true"
                />
              </b-button>
            </div>
            <div
              v-if="formIsValid"
              class="mr-1"
            />
          </div>

          <div
            v-if="!cardholderIntAddress"
            class="row text-center d-flex justify-content-center w-100 mr-0 ml-0"
          >
          <b-col
              v-if="formIsValid && isCompatiable"
              :cols="mobile ? '12': '6'"
            >
              <ApplePay
                class="mt-2 w-100 apple-pay-btn"
                :form-data="formData"
                :form-invalid="formIsValid"
                :is-compatiable="isCompatiable"
                :payment-cost="paymentAmount.toString()"
                @on-submit="applePaySubmit($event)"
                @set-form-invalid="setFormInvalid"
              />
              </b-col>
            <b-col :cols="mobile ? '12': '6'"
              v-if="formIsValid && !isCompatiable"
            >
              <GooglePay
                class="mt-2 w-100"
                :form-data="formData"
                :form-invalid="formIsValid"
                :payment-cost="paymentAmount.toString()"
                @on-submit="googlePaySubmit($event)"
                @set-form-invalid="setFormInvalid"
              />
            </b-col>
          </div>
        </div>
      </div>

      <div v-if="barclaysError === false && finalPayment === true">
        <h6>
          <p class="text-center">Payment amount:</p>
        </h6>
        <h4>
          <p class="text-center">
            {{ bookingInfo.booking_currency }}{{ paymentCost }}
          </p>
        </h4>
        <p
          v-if="barclaysLoadingError === false"
          class="text-center"
        >
          As soon as your payment has been approved we will email you with
          confirmation
        </p>
        <div
          v-if="barclaysLoadingError"
          class="text-center"
        >
          <b-alert
            show
            variant="danger"
          >
            We could not process your payment. Please contact your
            consultant.<br>Error: {{ barclaysLoadingErrorText }}
          </b-alert>
        </div>
        <div class="loading-state" v-if="paymentLoading">
            <div class="spinner"></div>
          </div>
        <iframe
          v-if="!paymentLoading"
          id="payment-frame"
          :src="barclaysUrl"
        />
      </div>

      <div
        v-if="barclaysError"
        class="text-center"
      >
        <b-card
          bg-variant="danger"
          border-variant="orangered"
          text-variant="white"
          class="my-4 text-center error-message"
        >
          <h6 v-if="booking.account_information.fil === 'M'">
            Your Payment was NOT successfully processed.
          </h6>
          <h5>
            Unfortunately we have not been able to process your payment and your
            card
            <strong style="color: darkgrey">has not been charged</strong>.
            <br>
            Please contact your local
            <a
              style="color: darkgrey"
              href="`/travel-centre/${booking.booking_information.branch_number}`"
            ><strong>Travel Centre</strong></a>
            for help. <br><br>
            Thank you
          </h5>
          <br>
          <p
            v-if="getPlatform !== 'iOS'"
            class="reload-text"
          >
            You will be redirected back to the app, please wait...
          </p>
          <i class="material-icons mr-3 reload-icon"></i>
        </b-card>
      </div>
      <div
        v-if="barclaysSuccess"
        class="text-center"
      >
        <b-card
          bg-variant="success"
          border-variant="orangered"
          text-variant="white"
          class="my-4 text-center success-message"
        >
          <h6 v-if="booking.account_information.fil === 'M'">
            Your Payment has been processed.
          </h6>
          <h5>
            Thank You. Your payment has been received and we have sent you a
            confirmation email.
            <br>
            Please contact your local
            <a
              style="color: black"
              href="`/travel-centre/${booking.booking_information.branch_number}`"
            ><strong>Travel Centre</strong></a>
            if you have any queries. <br><br>
          </h5>
          <div>
            <p
              v-if="getPlatform !== 'iOS'"
              class="reload-text"
            >
              You will be redirected back to the app, please wait...
            </p>
            <p
              v-if="getPlatform === 'iOS'"
              class="reload-text"
            >
              You will be taken back to Payments & Booking Conditions, please
              wait...
            </p>
            <i class="material-icons mr-3 reload-icon"></i>
          </div>
          <br>
        </b-card>
      </div>
    </div>
    <div class="loading-state" v-if="showLoadingSpinner">
      <div class="spinner"></div>
    </div>
  </span>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { countryCodes } from "@/assets/countryCodes";
import platform from "platform";
import GooglePay from "../../../../partials/google-pay";
import ApplePay from "../../../../partials/apple-pay";
const { VUE_APP_APPLE_PAY_MERCH_ID } = process.env;
import {
  paymentConfirm,
  amexButtonPayment,
  logToPapertrail,
} from "../../../navigation/modals/payment-hub/make-payment/services";
import {
  getUrl,
  generateTCEmailAddress,
} from "../../../navigation/modals/payment-hub/make-payment/account.module.js";
import { required } from "vuelidate/lib/validators";
import { getTravellingPassengers } from '../../../../lib/utilities';

export default {
  components: {
    GooglePay,
    ApplePay,
  },
  data() {
    return {
      showLoadingSpinner: true,
      barclaysData: {},
      showPaymentOptions: false,
      formIsValid: false,
      formInvalid: false,
      paymentLoading: false,
      isFormValid: false,
      modalPayType: "contactless",
      canMakeApplePayments: false,
      historyDropdown: false,
      methodsDropdown: false,
      checkboxStatus: false,
      checkboxInsurance: false,
      checkboxInsuranceModalConfirm: "false",
      showAmexButton: true,
      paymentCost: 0,
      paymentName: null,
      paymentEmail: null,
      titles: ["Select", "MR", "MRS", "MISS", "MS"],
      cardholderTitle: "",
      cardholderName: "",
      cardholderSurname: "",
      cardholderIntAddress: false,
      cardholderCountryCode: null,
      cardholderAddress1: "",
      cardholderAddress2: "",
      cardholderAddress3: "",
      cardholderPostcode: "",
      finalPayment: false,
      socket: null,
      barclaysUrl: "",
      barclaysError: false,
      barclaysSuccess: false,
      mobile: window.innerWidth <= 700,
      bookingNames: null,
      continuePayment: false,
      barclaysLoadingError: false,
      barclaysLoadingErrorText: "",
      paytype: "card",
      finalPaymentCost: "",
      version: process.env.PACKAGE_VERSION || "0",
      paymentClickedError: false,
      countryCodes: countryCodes,
      selectedPassenger: null,
    };
  },
  validations() {
    return {
      cardholderSurname: { required },
      cardholderName: { required },
      cardholderAddress1: { required },
      cardholderAddress2: { required },
      cardholderPostcode: { required },
      cardholderTitle: { required },
    };
  },
  created() {
    // Show loading spinner
    this.showLoadingSpinner = true
    this.checkApplePay();
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 700;
    });
  },
  computed: {
    ...mapGetters({
      receipts: "account/getReceipts",
      summary: "account/getSummary",
      officeOpen: "account/getOfficeInfo",
      accountInfo: "booking/getAccount",
      booking: "booking/getBooking",
      bookingNo: "booking/getBookingNumber",
      bookingInfo: "booking/getBookingInfo",
      userData: "auth/getUserData",
      paxNames: "booking/getBookingPassengers",
    }),
    showOnlinePayments() {
      if (
        (this.accountInfo.paybal_wbt === "true" &&
          this.accountInfo.paybal_menu === "false") ||
        (this.accountInfo.paybal_wbt === "false" &&
          this.accountInfo.paybal_menu === "false") ||
        (this.accountInfo.paybal_wbt === "true" &&
          this.accountInfo.paybal_menu === "false")
      ) {
        return false;
      }
      return true;
    },
    insuranceYear() {
      return new Date().getFullYear();
    },
    payDisplay() {
      return this.booking.account_information.balanceCost;
    },
    fullPayment() {
      if (
        this.bookingInfo.holiday_type &&
        this.bookingInfo.holiday_type.code === "FO"
      ) {
        return true;
      }
      return false;
    },
    getPlatform() {
      return platform.os.family;
    },
    paymentButtonActive() {
      if (
        (this.checkboxStatus === true && this.checkboxInsurance === false) ||
        (this.checkboxStatus === true && this.checkboxInsurance === "false")
      ) {
        return true;
      } else if (
        this.checkboxStatus === true &&
        this.accountInfo.insquoteamount != "" &&
        this.checkboxInsuranceModalConfirm === "true"
      ) {
        return true;
      }
      return false;
    },
    formData() {
      return this.buildBarclaysData();
    },
    isCompatiable() {
      return this.canMakeApplePayments;
    },
    paymentAmount() {
      return this.paymentCost;
    },
    passengerOptions() {
      const arr = [{ value: null, text: "Please select who is paying..." }];
      if (this.paxNames && this.paxNames.length) {
        const travellingPax = getTravellingPassengers(
          this.booking.user_information.names, this.paxNames
        )
        travellingPax.forEach((pax) => {
          arr.push({
            text: pax.name,
            value: pax,
          });
        });
        arr.push({ value: "guest", text: "Somebody not travelling" });
        return arr;
      }
      return arr;
    },
  },
  async mounted() {
    this.loginRes = await this.loginOnStart({
      username: this.$route.params.surname,
      bookingNumber: this.$route.params.bookingNumber,
      source: this.$route.params.source,
    });
    if (
      this.accountInfo &&
      this.booking &&
      this.$route.name === "contactlessPayment"
    ) {
      this.startCardPayment("contactless");
      this.showLoadingSpinner = false
    }
  },
  methods: {
    ...mapActions({
      loginOnStart: "auth/loginBookingNumberOnStartAction",
      login: "auth/loginBookingNumberAction",
    }),
    handleOkInsuranceModal() {
      if (this.checkboxInsuranceModalConfirm === "false") {
        this.checkboxInsurance = "false";
      }
      this.$bvModal.hide("ins-conf-modal");
    },
    dropDown(arg) {
      switch (arg) {
        case "paymenthistory":
          this.historyDropdown = !this.historyDropdown;
          if (this.historyDropdown && this.methodsDropdown) {
            this.methodsDropdown = !this.methodsDropdown;
          }
          break;
        case "methods":
          this.methodsDropdown = !this.methodsDropdown;
          if (this.methodsDropdown && this.historyDropdown) {
            this.historyDropdown = !this.historyDropdown;
          }
          break;
      }
    },
    setFormInvalid() {
      this.formInvalid = true;
    },
    async checkboxUpdate() {
      if (this.checkboxStatus === true) {
        paymentConfirm(
          this.booking.booking_information.lead_surname.toLowerCase(),
          this.bookingNo
        );
      }
    },
    insuranceCheckboxUpdate() {
      if (
        this.checkboxInsurance === false ||
        this.checkboxInsurance === "false"
      ) {
        this.$refs["ins-conf-modal"].show();
      }
      this.paymentCost = this.checkFinalPayment();
    },
    checkFinalPayment() {
      if (
        this.checkboxInsurance === true ||
        this.checkboxInsurance === "true" || this.$route.query.incProvIns === true || this.$route.query.incProvIns === 'true'
      ) {
        return (
          Math.round(
            (Number(this.accountInfo.balanceCostNoSymbol) +
              Number(this.accountInfo.insquoteamount)) *
              100
          ) / 100
        );
      } else {
        return this.accountInfo.balanceCostNoSymbol.trim();
      }
    },
    async loadBankTransfer() {
      this.paymentCost = this.checkFinalPayment();
      this.paymentEmail = this.booking.user_information.email;
      this.paymentName = this.booking.user_information.names[0];
      this.$refs.banktransfer.toggle();
    },
    async clickBankTransfer() {
      // Check if checkbox complete
      if (this.checkboxStatus === false) {
        this.paymentClickedError = true;
        return;
      }
      await this.loadBankTransfer();
    },
    //Launch amex bank payment popup window for UK only
    // today make this page dropdowns copy pasta from geroges changes
    async loadAmexButton() {
      // instead of paxnames it will be the passenger selected in the dropdown or guest
      await amexButtonPayment(this.booking, this.paymentCost, this.paxNames);
    },
    async startCardPayment(payType) {
      // Check if checkbox complete
      if (
        this.checkboxStatus === false &&
        this.$route.name !== "contactlessPayment"
      ) {
        this.paymentClickedError = true;
        return;
      }
      this.paytype = "card";
      this.loadCardPayment(payType);
    },
    proceedCardPayment(payType) {
      this.continueCardPayment = true;
      this.loadCardPayment(payType);
    },
    loadCardPayment(payType) {
      // delete below when tested
      // this.paymentEmail = this.booking.user_information.email;
      // this.paymentCost = this.checkFinalPayment();
      // this.cardholderTitle = this.booking.user_information.bookingAddress.name1.split(
      //   " "
      // )[0];
      // this.cardholderName = this.booking.user_information.bookingAddress.name1.split(
      //   " "
      // )[1];
      // this.cardholderSurname = this.booking.user_information.bookingAddress.name1.split(
      //   " "
      // )[2];
      // this.cardholderAddress1 = this.booking.user_information.bookingAddress.address_01;
      // this.cardholderAddress2 = this.booking.user_information.bookingAddress.address_02;
      // this.cardholderAddress3 = this.booking.user_information.bookingAddress.address_03;
      // this.cardholderPostcode = this.booking.user_information.bookingAddress.postcode;
      this.paymentCost = this.checkFinalPayment();
      let socket_url = location.hostname === "localhost" ? "http://localhost:8318" : ''
      let socket_path = "/so-api/barclay/socket";
      let sent_error = false;
      this.socket = window.io(socket_url, {
        path: socket_path,
        transports: ["polling"],
      });
      this.socket.on("connect_error", async () => {
        if (sent_error === false) {
          sent_error = true;
          await logToPapertrail(
            "Payment Socket Error - connection failure: " +
              this.bookingNo +
              " " +
              platform.description
          );
        }
      });
      this.modalPayType = payType;
    },
    checkValidDetails() {
      this.formInvalid = false;
      this.showPaymentOptions = false;
      if (
        (Number(this.paymentCost) <= 0) |
        (this.cardholderTitle === "") |
        (this.cardholderName === "") |
        (this.cardholderSurname === "") |
        (this.cardholderAddress1 === "") |
        (this.cardholderAddress2 === "") |
        (this.cardholderPostcode === "")
      ) {
        this.formInvalid = true;
        this.formIsValid = false;
        return false;
      } else {
        this.showPaymentOptions = true;
        this.formIsValid = true;
        return true;
      }
    },
    buildBarclaysData() {
      let barclaysData = {};
      barclaysData.name =
        this.cardholderTitle +
        " " +
        this.cardholderName +
        " " +
        this.cardholderSurname;
      barclaysData.title = this.cardholderTitle;
      barclaysData.firstname = this.cardholderName;
      barclaysData.surname = this.cardholderSurname;
      barclaysData.billingAddressLine1 = this.cardholderAddress1;
      barclaysData.billingAddressLine2 = this.cardholderAddress2;
      barclaysData.billingAddressLine3 = this.cardholderAddress3;
      barclaysData.billingAddressPostcode = this.cardholderPostcode;
      if (
        this.booking.user_information.bookingNumber.charAt(0).toUpperCase() ===
        "R"
      ) {
        const postcodeSegments = barclaysData.billingAddressPostcode.split(" ");
        if (
          Array.isArray(postcodeSegments) &&
          postcodeSegments.length === 2 &&
          postcodeSegments[0] === "IRELAND"
        ) {
          barclaysData.billingAddressLine3 = postcodeSegments[0];
          barclaysData.billingAddressPostcode = postcodeSegments[1];
        }
      }
      if (this.cardholderIntAddress && this.cardholderCountryCode !== null) {
        barclaysData.countryCode = this.cardholderCountryCode;
      }
      barclaysData.logname = this.bookingInfo.logname;
      barclaysData.branchno = this.bookingInfo.branch_number;
      barclaysData.bookno = this.booking.user_information.bookingNumber;
      barclaysData.fil = this.accountInfo.fil;
      barclaysData.country = this.getTerritory();
      barclaysData.site = "TF";
      barclaysData.purchaseDescription =
        this.booking.user_information.bookingNumber;
      barclaysData.currencyCode =
        this.bookingInfo.booking_currency === "£" ? "GBP" : "EUR";
      barclaysData.purchaseAmount = this.paymentCost;
      barclaysData.holidayType = (this.bookingInfo.holiday_type && this.bookingInfo.holiday_type.code) ? this.bookingInfo.holiday_type.code : "";
      barclaysData.vt_data = {
        send_to: this.paymentEmail, // who to send it to.
        reply_to: generateTCEmailAddress(
          this.booking.booking_information.branch_number
        ),
        lead_surname: this.booking.booking_information.lead_surname,
        consultant: this.booking.consultant_information.name,
        balancenoCost: this.booking.account_information.balanceCostNoSymbol,
        fil: this.booking.booking_information.fil,
        branchTelephone: this.booking.booking_information.branch_number,
        originator_system: "finalpayment",
      };
      this.barclaysData = barclaysData;
      return barclaysData;
    },
    googlePaySubmit(googleData) {
      // let isValid = this.checkValidDetails()
      // if (isValid) {
      this.sfError = false;
      this.formInvalid = false;
      if (
        googleData &&
        googleData.detail.paymentMethodData.tokenizationData.token
      ) {
        this.formData.payType = "GooglePay";
        this.formData.sessionToken =
          googleData.detail.paymentMethodData.tokenizationData.token;
      }
      if (
        googleData &&
        !googleData.detail.paymentMethodData.tokenizationData.token
      ) {
        this.paymentError = true;
      }
      this.isLoading = true;
      this.cardPaymentNext();
      // } else {
      //   this.formInvalid = true
      // }
    },
    async applePaySubmit(appleData) {
      this.finalPayment = true;
      if (appleData) {
        this.formData.payType = "ApplePay";
        this.token = JSON.stringify(appleData);
        this.formData.sessionToken = JSON.stringify(appleData);
      }
      this.cardPaymentNext();
    },
    cardPaymentNext() {
      if (this.checkValidDetails()) {
        this.finalPayment = true;
        this.formData.auxSocketId = "";
        if (this.$route.query.auxSocketId) {
          this.formData.auxSocketId = this.$route.query.auxSocketId;
        }
        if (this.$route.query.incProvIns) {
          this.formData.vt_data.incProvIns = this.$route.query.incProvIns;
        }
        if (this.$route.query.issueFlights) {
          this.formData.vt_data.issueFlights = this.$route.query.issueFlights;
        }
        this.formData.id = this.selectedPassenger.id;
        this.socket.emit("begin", this.formData);
        let self = this;
        self.barclaysLoadingError = false;
        self.paymentLoading = true;
        //Initial call for card payment
        this.socket.on("beginResponse", function (beginResponse) {
          if (!beginResponse) {
          }
          if (beginResponse.paymentRedirectUrl) {
            self.barclaysUrl = beginResponse.paymentRedirectUrl;
            self.paymentLoading = false;
          } else if (beginResponse.error && beginResponse.error[0].message) {
            self.barclaysLoadingErrorText = beginResponse.error[0].message;
            self.barclaysLoadingError = true;
            self.paymentLoading = false;
          } else {
            self.paymentLoading = false;
            // self.barclaysLoadingErrorText =
            //   "Error taking payment. Please try again.";
            // self.barclaysLoadingError = true;
          }
        });
        //Completion of card payment
        this.socket.on("finished", function (finishedResponse) {
          self.paymentLoading = true;
          if (
            !finishedResponse.result ||
            finishedResponse.status >= 400 ||
            finishedResponse.error ||
            (finishedResponse.result && !finishedResponse.result.status) ||
            (finishedResponse.result &&
              finishedResponse.result.status !== "success")
          ) {
            self.paymentLoading = false;
            let message = this.bookingNo;
            if (finishedResponse.error) {
              if (finishedResponse.error.name) {
                message += " " + finishedResponse.error.name;
              }
              if (finishedResponse.error.content) {
                let content = JSON.parse(finishedResponse.error.content);
                message += " " + content.cancelReasonText;
                message += " " + JSON.stringify(content.billingAddress);
              }
            }

            // self.barclaysError = true;
            if (self.$route.query.google) {
              window.open(
                `payment://${self.$route.params.bookingNumber}/${self.$route.params.surname}`
              );
              window.close();
              self.paymentLoading = false;
              // window.open('https://trailfinders.com/viewtrail/payment')
            }
          } else {
            self.barclaysSuccess = true;
            self.barclaysError = false;
            self.finalPayment = false;
            if (self.$route.query.google) {
              window.open(
                `payment://${self.$route.params.bookingNumber}/${self.$route.params.surname}`
              );
              window.close();
              self.paymentLoading = false;
              setTimeout(() => {
                if (self.socket) {
                  self.socket.disconnect();
                }
              }, 10000);
              // window.open('https://trailfinders.com/viewtrail/payment')
            } else {
              setTimeout(() => {
                if (self.socket) {
                  self.socket.disconnect();
                }
                window.close();
                self.paymentLoading = false;
                // self.finalPayment = false;
                // self.barclaysError = false;
                // self.barclaysSuccess = false;
                // self.handlePageRefresh();
              }, 10000);
            }
          }
        });
      } else {
        this.formInvalid = true;
      }
    },
    closeProvisionalModal() {
      this.$refs["provisional-booking"].hide();
    },
    //Card payment modal closed
    closePaymentModal() {
      if (this.socket) {
        this.socket.disconnect();
      }
      this.finalPayment = false;
      this.barclaysError = false;
      this.barclaysSuccess = false;
      this.showPaymentOptions = false;
      this.formIsValid = false;
      //   this.$refs["card-transfer"].hide();
    },
    displayPayMenu() {
      // Only display on first flight and its mention in the booking declinks
      if (this.bookingInfo.desclinks.indexOf("pay_balance") !== -1) {
        return true;
      }
      return false;
    },
    // Switch to Itinerary tab
    switchItinerary() {
      this.$emit("switchtoitinerary");
    },
    openVisaAdviceModal() {
      this.$root.$emit("visaadvice");
    },
    openTravelHealthModal() {
      this.$root.$emit("travelhealth");
    },
    openCancellationsModal() {
      this.$root.$emit("cancellationconditions");
    },
    openUrlLink(arg) {
      const url = this.getUrlLink(arg);
      window.open(url, "_blank");
    },
    makeCall() {
      window.open(`tel:${this.getbookingContactNumber(this.booking)}`);
    },
    getUrlLink(arg) {
      return getUrl(arg, this.booking);
    },
    getbookingContactNumber(bookingObj) {
      if (bookingObj) {
        return bookingObj.user_information.bkgcontacts[0].line0.telno;
      }
    },
    getTerritory() {
      return this.bookingInfo.booking_site === "com" ? "UK" : "IE";
    },
    getCardPaymentErrorPanelHeight() {
      return this.mobile === true ? "height:170px" : "height:130px";
    },
    getCardPaymentSuccessPanelHeight() {
      return this.mobile === true ? "height:225px" : "height:130px";
    },
    openInsPolicyDoc() {
      let url = "";
      if (
        this.booking.user_information.bookingNumber.charAt(0).toLowerCase() ===
        "r"
      ) {
        url =
          "https://www.trailfinders.ie/travel-insurance/iepolicy" +
          new Date().getFullYear() +
          "v3.pdf";
      } else {
        url =
          "https://www.trailfinders.com/travel-insurance/ukpolicy" +
          new Date().getFullYear() +
          "v3.pdf";
      }
      window.open(url, "_blank");
    },
    async handlePageRefresh() {
      // If URL contains params reload the page if not redirect to url with the correct params
      if (this.$route.params.bookingNumber && this.$route.params.surname) {
        location.reload();
      } else {
        const url = `${location.href}/${this.userData.bookno}/${
          this.userData.clientname
            ? this.userData.clientname
            : this.userData.name
        }/${this.userData.source.toLowerCase()}`;
        location.href = url;
        location.reload();
      }
      window.scroll(0, 0);
    },
    checkApplePay() {
      if (window.ApplePaySession) {
        const merchantIdentifier = VUE_APP_APPLE_PAY_MERCH_ID;
        const validCardCheck =
          window.ApplePaySession.canMakePaymentsWithActiveCard(
            merchantIdentifier
          );
        validCardCheck.then((canMakePayments) => {
          this.canMakeApplePayments = canMakePayments;
          return canMakePayments;
        });
      } else {
        this.canMakeApplePayments = false;
        return false;
      }
    },
    toggleEdit() {
      this.showPaymentOptions = !this.showPaymentOptions;
      this.formIsValid = false;
    },
    findPersonalData() {
      if (this.selectedPassenger && this.selectedPassenger !== "guest") {
        const [passenger] = this.paxNames.filter(
          (pax) => pax.id === this.selectedPassenger.id
        );
        this.cardholderTitle = passenger.title;
        this.cardholderName = passenger.firstname;
        this.cardholderSurname = passenger.surname;
        this.cardholderAddress1 = passenger.address1;
        this.cardholderAddress2 = passenger.address2;
        this.cardholderAddress3 = passenger.address3;
        this.cardholderPostcode = passenger.postcode;
        this.paymentEmail = passenger.email;
      } else {
        this.cardholderTitle = "";
        this.cardholderName = "";
        this.cardholderSurname = "";
        this.cardholderAddress1 = "";
        this.cardholderAddress2 = "";
        this.cardholderAddress3 = "";
        this.cardholderPostcode = "";
        this.paymentEmail = "";
      }
    },
  },
  watch: {
    booking: function (_val) {
      if (this.getTerritory() === "UK") {
        this.finalPaymentCost = `£${this.paymentCost}`;
      } else {
        this.finalPaymentCost = `€${this.paymentCost}`;
      }
    },
  },
};
</script>
<style lang="scss">
  @import '../../../../partials/spinner/styles.scss';
</style>
<style lang="scss" scoped>
#payment-frame {
  border: 0px;
  margin: auto;
  width: 100%;
  height: 400px;
}
.icon-apple {
  background-image: url("https://cdn.trailfinders.com/v3vytopti5_apple-google-pay.png");
  background-size: cover;
  display: inline-block;
  margin: 5px;
  height: 45px;
  width: 140px;
  border-radius: 5px;
}
.icon-google {
  background-image: url("https://cdn.trailfinders.com/gonjwlc5vf_google-pay.png");
  background-size: cover;
  display: inline-block;
  height: 55px;
  width: 75px;
  border-radius: 5px;
}
.pay-btn {
  border-radius: 10px !important;
  min-height: 77%;
  font-weight: 700;
}
.edit-btn {
  border-radius: 10px !important;
  border-color: black;
  font-weight: 700;
}
.pay-header {
  background-color: #fcb134 !important;
  border-color: #fcb134 !important;
  color: black !important;
}
hr {
  margin: 40px 0;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.item-top {
  width: 100%;
  margin-bottom: 2%;
}
.item-three {
  width: 33%;
  height: 100px;
  margin-bottom: 2%;
}
.refresh-container {
  width: 100%;
}
.refresh-btn {
  width: 100%;
  background-color: #76c95f;
  display: flex;
  justify-content: center;
}
@media (max-width: 800px) {
  .flex-container {
    flex-direction: column;
  }
  .item-three {
    width: 100%;
    height: 100px;
    margin-bottom: 2%;
  }
  .booking-p {
    font-size: 1.2rem;
  }
}
.pay-lists {
  background-color: #fbfbc2;
}
.border-grey {
  border: 1px solid lightgrey;
  border-radius: 5px;
}
.close-x {
  margin-top: -5px;
  position: relative;
  top: -5px;
  right: 5px;
}
.custom-control-label h5 {
  padding-top: 5px !important;
}
.paylink {
  cursor: pointer;
  color: #99be6a;
  margin-bottom: 0;
}

.reload-text {
  font-size: 25px;
  margin: 30px 0 15px 0;
  text-align: center !important;
}
.reload-icon {
  font-size: 60px;
}
.refCardTransfer {
  background-color: #76c95f;
}
.refCardTransfer .modal-title {
  margin: 1rem;
}
.refCardTransfer .modal-header {
  max-height: 70px !important;
}
.error-field {
  color: red;
}
.booking {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.card-h6 {
  color: rgb(170, 170, 170);
  font-size: 0.9rem;
}

payment-container .no-apple-pay {
  padding: 20px !important;
}
.success-message .card-body {
  background-color: #28a745 !important;
}
.error-message .card-body {
  background-color: #dc3545 !important;
}
.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.spinner {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 10px solid #ddd;
  border-top-color: orange;
  animation: loading 1s linear infinite;
}
@keyframes loading {
  to {
    transform: rotate(360deg);
  }
}
</style>
